import { Scrollbar } from "./Scrollbar.js";
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  Scrollbar
};
//# sourceMappingURL=index.js.map
